import { render } from "./MediaBlock.vue?vue&type=template&id=b3dd70ea&scoped=true"
import script from "./MediaBlock.vue?vue&type=script&lang=js"
export * from "./MediaBlock.vue?vue&type=script&lang=js"

import "./MediaBlock.vue?vue&type=style&index=0&id=b3dd70ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3dd70ea"]])

export default __exports__